'use strict';
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./numeric-quantity.cjs.production.js');
} else {
  module.exports = require('./numeric-quantity.cjs.development.js');
}
